import "./statistics-export.scss";
import {
  FilePdfOutlined,
  FileExcelOutlined,
  FileWordOutlined,
} from "@ant-design/icons";
import CardWrapper from "../../HOC/card/card";

const StatisticsExport = ({ excelUrl, wordUrl, pdfUrl }) => {
  return (
    <CardWrapper>
      <div className="export-conatiner">
        تصدير التقارير
        <FilePdfOutlined /> <FileWordOutlined /> <FileExcelOutlined />
      </div>
    </CardWrapper>
  );
};
export default StatisticsExport;
